import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Approach from "./pages/Approach";
import Engagements from "./pages/Engagements";
import Perspective from "./pages/Perspective";
import Infrastructure from "./pages/Infrastructure";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/engagements" element={<Engagements />} />
            <Route path="/perspective" element={<Perspective />} />
            <Route path="/infrastructure" element={<Infrastructure />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
